"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatTvCodeError = formatTvCodeError;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require("react-intl");

var _DefaultString = require("./DefaultString");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formatTvCodeError(errorMessage) {
  switch (errorMessage) {
    case "INVALID_CODE":
    case "CODE_NOT_FOUND":
      return _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.TVCodeFormInvalidCode);
    case "CODE_NOT_SENT":
    case "NO_RESPONSE":
      return _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.TVCodeFormNoResponse);
    default:
      return errorMessage;
  }
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/FormatTvCodeError.js
// module id = 815
// module chunks = 0